module.exports = __webpack_public_path__ + "static/media/logo-white.d0ece74c.svg";